module.exports = __webpack_public_path__ + "img/Keuring.e3100ae9.svg";